export default "__VITE_ASSET__BHBPD6hL__"